module.exports = __webpack_public_path__ + "static/img/solutionDetailPic22.abf87ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic22.jpg
// module id = YNUd
// module chunks = 1